import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import WPP8MPage from './components/WPP8MPage';
import Terminos from './components/Terminos';
import UsersList from './components/UsersList';
import Cronograma from './components/Cronograma';


function App() {
    return (
        <Router>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<WPP8MPage />} />
                <Route path="/cronograma" element={<Cronograma />} />
                <Route path="/terminos" element={<Terminos />} />
                <Route path="/registros" element={<UsersList />} />
            </Routes>
        </Router>
    );
}

export default App;
